/**
 * Logger — wrapper na console który milknie w produkcji.
 *
 * Użycie:
 *   import { logger } from '@/utils/logger';
 *   logger.error('Failed:', err);
 *   logger.warn('Auth not configured');
 *   logger.log('[Auth] No session');
 *
 * W produkcji (NODE_ENV === 'production') wszystkie wywołania to no-op.
 * W development tracza tak samo jak console.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
  log: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
  info: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
};

export default logger;
